/* Auto-submit the storefront filter form and close open filter popovers on outside click. */
(function () {
  function init() {
    var form = document.querySelector('[data-collection-form]');
    if (!form) return;
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) return;
      form.requestSubmit();
    });
    document.addEventListener('click', function (e) {
      if (e.target.closest('.filter-group')) return;
      form.querySelectorAll('.filter-group[open]').forEach(function (d) {
        if (!d.querySelector('input:checked')) d.removeAttribute('open');
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
